import { connect } from "react-redux";
import { createPromiseApiAction } from "redux-store/api-sagas";
import { FETCH_PARAM_MAPPINGS } from "redux-store/ui-state/param-mappings/actions";

import { FetchParamMappingController } from "./fetch-param-mapping-controller";

function mapDispatchToProps(dispatch) {
  return {
    fetchObject: () => {
      return createPromiseApiAction(dispatch, FETCH_PARAM_MAPPINGS);
    },
  };
}

const ConnectedFetchParamMappingController = connect(
  null,
  mapDispatchToProps,
)(FetchParamMappingController);

ConnectedFetchParamMappingController.propTypes = {
  children: FetchParamMappingController.propTypes.children,
  injectAs: FetchParamMappingController.propTypes.injectAs,
};

export { ConnectedFetchParamMappingController };
